module.exports = __webpack_public_path__ + "img/niews-4.c52123b1.jpeg";